module.exports = __webpack_public_path__ + "img/192.93b0d1c8.jpg";